<template>
  <div
    class="header-tools header-tools--full mr-2 ml-2 mb-md-4 mb-2 flex-wrap-sm"
  >
    <h2
      class="
        header-tools__title
        ml-md-4 ml-auto
        order-1 order-md-0
        mb-2 mb-md-0
      "
    >
      {{ title }}
    </h2>
    <div
      class="
        header-tools__block header-tools__block--no-m-sm
        ml-0
        mr-auto
        order-5 order-md-0
      "
    >
      <div class="header-tools__actions">
        <button
          class="header-tools__action-btn js-tooltip"
          @click.stop="$emit('delete')"
          title="מחיקה"
        >
          <icon name="students-delete" />
        </button>
      </div>
    </div>

    <div
      class="
        header-tools__block header-tools__search
        order-4 order-md-0
        ml-0 ml-md-4
        mr-md-4
      "
    >
      <div class="search-form">
        <slot name="filter">
          <div class="search-form__filter">
            <div
              :class="
                'search-form__filter-btn ' + (showFilter ? ' active ' : '')
              "
              @click.stop="showFilter = !showFilter"
            >
              <icon name="serviceFilter" />
              <div class="tooltip bot">מסנן</div>
            </div>
            <div
              :class="{ active: showFilter }"
              class="search-form__filter-panel"
              @click.stop
            >
              <div class="search-form__filter-panel-title h3">מסנן</div>
              <div class="form__row">
                <div class="form__field">
                  <div class="form__field-label">קבוצה</div>
                  <Select2
                    :disabled="filter_groups.length === 1"
                    v-model="filterForm.group_id"
                    :options="filter_groups"
                    :settings="{
                      multiple: false,
                      minimumResultsForSearch: -1
                    }"
                    class="form__field-select"
                  />
                </div>
                <div class="form__field">
                  <div class="form__field-label">כיתה</div>
                  <Select2
                    v-model="filterForm.class_id"
                    :options="filter_classes"
                    :disabled="filter_campuses.length === 1"
                    :settings="{
                      multiple: false,
                      minimumResultsForSearch: -1
                    }"
                    class="form__field-select"
                  />
                </div>
              </div>

              <div class="form__row">
                <div class="form__field">
                  <label for="filter-checkbox" class="checkbox not-empty">
                    <input
                      id="filter-checkbox"
                      v-model="filterForm.need_to_watch"
                      type="checkbox"
                      class="checkbox__input not-empty"
                    />
                    <div class="checkbox__marker" />
                    <div class="checkbox__text">דורש טיפול</div>
                  </label>
                </div>
              </div>
              <div class="form__row">
                <div class="form__field">
                  <label
                    for="filter-checkbox-deleted"
                    class="checkbox not-empty"
                  >
                    <input
                      id="filter-checkbox-deleted"
                      v-model="filterForm.deleted_also"
                      type="checkbox"
                      class="checkbox__input not-empty"
                    />
                    <div class="checkbox__marker" />
                    <div class="checkbox__text">תלמידים שנמחקו</div>
                  </label>
                </div>
              </div>
              <div class="form__row">
                <button
                  class="form__field-btn btn btn--blue"
                  @click="$emit('filtering')"
                >
                  חפש
                </button>
              </div>
            </div>
          </div>
        </slot>

        <slot name="search">
          <div
            v-if="searchForm"
            class="search-form__search-btn"
            :class="{ active: searchForm.mobileSearchForm }"
            @click="searchForm.mobileSearchForm = !searchForm.mobileSearchForm"
          >
            <icon name="search-icon" />
            <icon name="decline-close" />
          </div>
          <div
            v-if="searchForm"
            class="search-form__body search-form__body--full-width"
            :class="{ active: searchForm.mobileSearchForm }"
          >
            <div class="search-form__field">
              <input
                v-model="searchForm.text"
                type="text"
                :maxlength="36"
                placeholder="חיפוש תלמידים"
                class="search-form__field-input"
                @input="$emit('search')"
              />
              <div class="search-form__field-icon">
                <icon name="search-1" width="16" height="16" />
              </div>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <slot name="button">
      <div
        v-if="$perm('student.create', selectedCampus ? selectedCampus.id : -1)"
        class="header-tools__block order-2 order-md-0 mb-2 mb-md-0"
      >
        <router-link
          to="#"
          @click.native="showModalAddStudent = true"
          class="btn btn--static-lg btn--blue btn--short-md"
        >
          <icon name="DropDownList-icon1" width="25" />
          <span>{{ btnText }}</span>
        </router-link>
      </div>
      <StudentModalAdd
        :selectedCampus="selectedCampus"
        v-if="showModalAddStudent"
        @close="showModalAddStudent = false"
        :status-id="statusId"
      />
    </slot>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StudentModalAdd from '../../Pages/Student/StudentModalAdd';
export default {
  name: 'StudentListHeader',
  components: { StudentModalAdd },
  props: {
    title: {
      type: String,
      required: true
    },
    statusId: {
      type: Number,
      required: 2
    },
    btnText: {
      type: String,
      default: 'הוסף מועמד'
    },
    search: {},
    filter: {}
  },
  data() {
    return {
      filter_campuses: [],
      filter_groups: [],
      filter_classes: [],
      searchForm: this.search,
      filterForm: this.filter,
      showModalAddStudent: false,
      showFilter: false
    };
  },
  computed: {
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    })
  },
  watch: {
    searchForm(val) {
      this.$emit('changeSearch', val);
    },
    filterForm(val) {
      this.$emit('changeFilter', val);
    }
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    selectCampusFilter(e) {
      this.getClassesForFilter(e.id);
      this.getGroupsForFilter(e.id);
      this.filterForm.group_id = 0;
      this.filterForm.class_id = 0;
    },
    getClassesForFilter(id) {
      if (id > 0) {
        this.$service
          .retrieve(this.$services.studentList.campusClassId, {
            urlParams: {
              class: id
            }
          })
          .then(res => {
            this.filterForm.class_id = 0;
            this.filter_classes = res.data.data;
            this.filter_classes.unshift({
              id: 0,
              text: '---'
            });
          });
      }
    },
    getGroupsForFilter(id) {
      if (id > 0) {
        this.$service
          .retrieve(this.$services.studentList.campusGroupId, {
            urlParams: {
              group: id
            }
          })
          .then(res => {
            this.filterForm.group_id = 0;
            this.filter_groups = res.data.data;
            this.filter_groups.unshift({
              id: 0,
              text: '---'
            });
          });
      }
    },
    async fetchData() {
      await this.getClassesForFilter(this.selectedCampus.id);
      await this.getGroupsForFilter(this.selectedCampus.id);
    }
  }
};
</script>

<style scoped></style>
